<template>
  <div>
    <div class="search-con search-con-top">
      <Select v-model="param.chname" filterable style="width:200px;" placeholder="请选择车行名">
        <Option value>全部</Option>
        <Option v-for="item in carServeList" :key="item.id" :value="item.name">{{item.name}}</Option>
      </Select>
      <Input clearable placeholder="输入设备号" class="search-input" v-model="param.devicenum" />
      <Input clearable placeholder="输入保单号" class="search-input" v-model="param.pnum" />
      <Input clearable placeholder="输入客户姓名" class="search-input" v-model="param.customername" />
      <Input clearable placeholder="输入录入人" class="search-input" v-model="param.username" />
      <Input clearable placeholder="输入第一受益人" class="search-input" v-model="param.firstbeneficiary" />
      <!-- <Input clearable placeholder="输入保单状态" class="search-input" v-model="param.policystate"/> -->
      <Select v-model="param.printstate" style="width:300px;" placeholder="选择销售单状态">
        <Option value>全部</Option>
        <Option value="1">未打印</Option>
        <Option value="2">已打印</Option>
        <Option value="3">已作废</Option>
      </Select>
      <DatePicker
        v-model="param.pstarttime"
        type="date"
        placeholder="输入开始日期"
        format="yyyy-MM-dd"
        class="search-input"
        style="width: 200px"
      ></DatePicker>
      <DatePicker
        v-model="param.pendtime"
        type="date"
        placeholder="输入结束日期"
        format="yyyy-MM-dd"
        class="search-input"
        style="width: 200px"
      ></DatePicker>
      <Button
        @click="searchInfo()"
        class="search-btn"
        v-if="this.$getMenuAuthority('sys:saleslip:list')"
        type="primary"
      >
        <Icon type="search" />搜索
      </Button>
      <Button
        @click="addInfo()"
        v-if="this.$getMenuAuthority('sys:saleslip:save')"
        class="search-btn"
        type="primary"
      >
        <Icon type="search" />新增
      </Button>
      <Button
        @click="exportInfo()"
        v-if="this.$getMenuAuthority('sys:saleslip:export')"
        class="search-btn"
        type="primary"
      >
        <Icon type="search" />导出
      </Button>
    </div>
    <Modal v-model="editModalShow" @on-ok="deleteInfo()" scrollable title="编辑">
      <Form
        ref="deleteValidate"
        :model="deleteValidate"
        :rules="ruleDeleteValidate"
        :label-width="80"
        class="edit-win"
      >
        <FormItem label="原因" prop="reason">
          <Select v-model="deleteValidate.reason" style="width:380px;">
            <Option value="1">退保</Option>
            <Option value="2">车主信息变更</Option>
            <Option value="3">设备信息变更</Option>
            <Option value="4">车辆信息变更</Option>
            <Option value="5">其他</Option>
          </Select>
        </FormItem>
        <FormItem label="备注" prop="remark">
          <Input v-model="deleteValidate.remark" placeholder="请输入备注" style="width: 380px" />
        </FormItem>
      </Form>
    </Modal>
    <Modal v-model="renewalModalShow" scrollable title="续期">
      <Form
        ref="renewalValidate"
        :model="renewalValidate"
        :rules="ruleRenewalValidate"
        :label-width="80"
        class="edit-win"
      >
        <Row>
          <Col span="10">
            <FormItem label="客户名称">{{renewalInfoShow.customername}}</FormItem>
            <FormItem label="开始时间">{{$formatTimeCN(renewalInfoShow.pstarttime)}}</FormItem>
            <FormItem label="保单号">{{renewalInfoShow.pnum}}</FormItem>
          </Col>
          <Col span="10">
            <FormItem label="车牌号码">{{renewalInfoShow.carnum}}</FormItem>
            <FormItem label="结束时间">{{$formatTimeCN(renewalInfoShow.pendtime)}}</FormItem>
            <FormItem label="剩余期限">{{renewalInfoShow.renewallimit}}</FormItem>
          </Col>
        </Row>
        <FormItem label="处理时间" prop="date">
          <DatePicker
            v-model="renewalValidate.date"
            type="date"
            placeholder="输入结束日期"
            format="yyyy-MM-dd"
            class="search-input"
            style="width: 380px"
          ></DatePicker>
        </FormItem>
        <FormItem label="处理意见" prop="opinion">
          <Input v-model="renewalValidate.opinion" placeholder="请输入意见" style="width: 380px" />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="renewalModalShow=false">取消</Button>
        <Button type="primary" size="large" @click="renewal()">确定</Button>
      </div>
    </Modal>
    <Table border :columns="columns1" :data="showData.list"></Table>
    <div class="page-con">
      <Page
        show-total
        :total="showData.total"
        :page-size="10"
        @on-change="chagepage"
        :current="showData.pageNum"
        show-elevator
        class="pull-right"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      editModalShow: false, //作废窗口显示
      renewalModalShow: false, //续期窗口显示
      param: {
        //查询条件
        chname: "",
        devicenum: "",
        pnum: "",
        customername: "",
        username: "",
        firstbeneficiary: "",
        policystate: "",
        printstate: "",
        pstarttime: "",
        pendtime: ""
      },
      showData: {
        //列表容器
        pageNum: 1
      },
      deleteValidate: {
        id: "",
        reason: "",
        remark: ""
      },
      ruleDeleteValidate: {
        reason: [{ required: true, message: "不能为空", trigger: "blur" }],
        remark: [{ required: true, message: "不能为空", trigger: "blur" }]
      },
      renewalValidate: {
        saleslipid: "",
        date: "",
        opinion: ""
      },
      carServeList: [],
      renewalInfoShow: {}, //续期用户信息
      ruleRenewalValidate: {
        date: [
          {
            required: true,
            message: "续期时间必选",
            trigger: "blur",
            type: "date"
          }
        ]
      },
      columns1: [
        //表头
        {
          title: "操作",
          key: "action",
          width: 250,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: { type: "primary", size: "small" },
                  style: {
                    marginRight: "5px",
                    display: this.$getMenuAuthority("sys:saleslip:print")
                      ? "inline-block"
                      : "none"
                  },
                  on: {
                    click: () => {
                      this.$router.push({
                        path: "/template/TemplateDetail",
                        query: { id: params.row.id }
                      });
                    }
                  }
                },
                "打印"
              ),
              h(
                "Button",
                {
                  props: { type: "primary", size: "small" },
                  style: {
                    marginRight: "5px",
                    display: this.$getMenuAuthority("sys:saleslip:renewal")
                      ? "inline-block"
                      : "none"
                  },
                  on: {
                    click: () => {
                      this.renewalValidate = {
                        saleslipid: "",
                        date: "",
                        opinion: ""
                      };
                      this.renewalValidate.saleslipid = params.row.id;
                      this.getInfoById(params.row.id);
                      this.renewalModalShow = true;
                    }
                  }
                },
                "续期"
              ),
              h(
                "Button",
                {
                  props: { type: "primary", size: "small" },
                  style: {
                    marginRight: "5px",
                    display: this.$getMenuAuthority("sys:saleslip:update")
                      ? "inline-block"
                      : "none"
                  },
                  on: {
                    click: () => {
                      this.editInfo(params.row.id);
                    }
                  }
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: { type: "error", size: "small" },
                  style: {
                    marginRight: "5px",
                    display: this.$getMenuAuthority("sys:saleslip:delete")
                      ? "inline-block"
                      : "none"
                  },
                  on: {
                    click: () => {
                      this.deleteValidate = {
                        id: "",
                        reason: "",
                        remark: ""
                      };
                      this.deleteValidate.id = params.row.id;
                      this.editModalShow = true;
                    }
                  }
                },
                "作废"
              )
            ]);
          }
        },
        { title: "销售单号", key: "salenum" },
        { title: "设备号", key: "devicenum" },
        { title: "保单号", key: "pnum" },
        {
          title: "销售单状态",
          align: "center",
          key: "policystate",
          render: (h, params) => {
            return h("div", this.getDeviceType(params.row.printstate));
          }
        },
        { title: "保单金额", key: "policyamount" },
        { title: "4s店名", key: "shop4s" },
        { title: "车主姓名", key: "customername" },
        { title: "手机号", key: "phone" },
        { title: "赔付金额", key: "compensation" },
        { title: "车牌号码", key: "carnum" },
        {
          title: "保单开始日期",
          align: "center",
          key: "pstarttime",
          render: (h, params) => {
            return h("div", this.$formatTimeCN(params.row.pstarttime));
          }
        },
        {
          title: "保单结束日期",
          align: "center",
          key: "pendtime",
          render: (h, params) => {
            return h("div", this.$formatTimeCN(params.row.pendtime));
          }
        },
        { title: "录入人", key: "creatorname" },
        { title: "第一受益人", key: "firstbeneficiaryname" }
      ]
    };
  },
  activated() {
    this.getCarServeList();
    this.getList();
  },
  mounted() {
    this.getCarServeList();
    this.getList();
  },
  methods: {
    searchInfo() {
      this.showData.pageNum = 1;
      this.getList();
    },
    chagepage(current) {
      this.showData.pageNum = current;
      this.getList();
    },
    getCarServeList() {
      //获取车行列表
      this.$Loading.start();
      this.$axios.get("/policy/group").then(
        function(response) {
          if (response.data.success) {
            this.carServeList = response.data.data;
            this.$Loading.finish();
          } else {
            this.$Message.error(response.data.errMsg);
            this.$Loading.error();
          }
        }.bind(this)
      );
    },
    exportInfo() {
      this.$Loading.start();

      this.param.pstarttime = this.$formatTimeCN(this.param.pstarttime);
      this.param.pendtime = this.$formatTimeCN(this.param.pendtime);
      this.$axios
        .get(
          "/saleslip/exportExcel?devicenum=" +
            this.param.devicenum +
            "&pnum=" +
            this.param.pnum +
            "&customername=" +
            this.param.customername +
            "&printstate=" +
            this.param.printstate +
            "&username=" +
            this.param.username +
            "&firstbeneficiary=" +
            this.param.firstbeneficiary +
            "&policystate=" +
            this.param.policystate +
            "&pstarttime=" +
            this.param.pstarttime +
            "&chname=" +
            this.param.chname +
            "&pendtime=" +
            this.param.pendtime,
          { responseType: "arraybuffer" }
        )
        .then(
          function(response) {
            const aLink = document.createElement("a");
            let blob = new Blob([response.data], {
              type: "application/vnd.ms-excel"
            });
            aLink.href = URL.createObjectURL(blob);
            aLink.setAttribute("download", "销售单" + ".xls"); // 设置下载文件名称
            aLink.click();
            //document.body.appendChild(aLink)
            this.$refs.loadElement.appendChild(aLink);
            this.$Loading.finish();
          }.bind(this)
        );
    },
    getList() {
      //获取列表
      this.$Loading.start();
      this.param.pstarttime = this.$formatTimeCN(this.param.pstarttime);
      this.param.pendtime = this.$formatTimeCN(this.param.pendtime);

      this.$axios
        .get(
          "/saleslip/list/" +
            this.showData.pageNum +
            "?devicenum=" +
            this.param.devicenum +
            "&pnum=" +
            this.param.pnum +
            "&customername=" +
            this.param.customername +
            "&printstate=" +
            this.param.printstate +
            "&username=" +
            this.param.username +
            "&firstbeneficiary=" +
            this.param.firstbeneficiary +
            "&policystate=" +
            this.param.policystate +
            "&pstarttime=" +
            this.param.pstarttime +
            "&chname=" +
            this.param.chname +
            "&pendtime=" +
            this.param.pendtime
        )
        .then(
          function(response) {
            if (response.data.success) {
              this.showData = response.data.data;
              this.$Loading.finish();
            } else {
              this.$Message.error(response.data.errMsg);
              this.$Loading.error();
            }
          }.bind(this)
        );
    },
    getDeviceType(type) {
      if (type == 1) {
        return "未打印";
      } else if (type == 2) {
        return "已打印";
      } else if (type == 3) {
        return "已作废";
      }
    },
    getSynType(type) {
      if (type == 1) {
        return "未验证";
      } else if (type == 2) {
        return "已验证";
      } else if (type == 3) {
        return "已作废";
      }
    },
    editInfo(id) {
      this.$router.push({ path: "/saleslip/edit", query: { id: id } });
    },
    addInfo() {
      this.$router.push("/saleslip/add");
    },
    deleteInfo(id) {
      this.$Loading.start();
      this.$axios.post("/saleslip/delete", this.deleteValidate).then(
        function(response) {
          if (response.data.success) {
            this.getList();
            this.$Loading.finish();
          } else {
            this.$Message.error(response.data.errMsg);
            this.$Loading.error();
          }
        }.bind(this)
      );
    },
    renewal() {
      this.$Loading.start();
      this.$refs.renewalValidate.validate(valid => {
        if (valid) {
          this.$axios.post("/saleslip/renewal", this.renewalValidate).then(
            function(response) {
              if (response.data.success) {
                this.getList();
                this.renewalModalShow = false;
                //console.log(123);
                this.$Loading.finish();
              } else {
                this.$Message.error(response.data.errMsg);
                this.$Loading.error();
              }
            }.bind(this)
          );
        }
      });
    },
    getInfoById(id) {
      this.$Loading.start();
      this.$axios.get("/saleslip/getRenewalInfo/" + id).then(
        function(response) {
          if (response.data.success) {
            this.renewalInfoShow = response.data.data;
            this.$Loading.finish();
          } else {
            this.$Message.error(response.data.errMsg);
            this.$Loading.error();
          }
        }.bind(this)
      );
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/views/saleslip/list.vue